"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceFactory = exports.orderFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
const sale_address_factory_1 = require("./sale-address.factory");
const sale_item_factory_1 = require("./sale-item.factory");
const sale_payment_factory_1 = require("./sale-payment.factory");
const sale_register_factory_1 = require("./sale-register.factory");
const sale_source_factory_1 = require("./sale-source.factory");
const sale_transaction_factory_1 = require("./sale-transaction.factory");
exports.orderFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    amount: Mocks.clare.numberTen,
    amount_outstanding: Mocks.clare.amountZero,
    amount_paid: Mocks.clare.amountTen,
    amount_refunded: Mocks.clare.amountZero,
    amount_charged_back: Mocks.clare.amountZero,
    amount_adjusted: Mocks.clare.amountZero,
    amount_credited: Mocks.clare.amountZero,
    can_comp: false,
    can_void: false,
    cart_id: 2,
    created_at: Mocks.dates.date2000,
    description: 'Test Order',
    email_address: Mocks.persona.email,
    org_id: Mocks.orgClub.id,
    organization_id: Mocks.orgClub.id,
    payment_plan_id: 3,
    payment_plan_payment_method: null,
    placed_at: Mocks.dates.date2000,
    placed_successfully: true,
    sale_number: Mocks.clare.saleNumber,
    salesperson_id: 4,
    salesperson_full_name: null,
    status: 'settled',
    monetary_status: 'paid',
    display_status: Mocks.clare.statusPaid,
    store_id: Mocks.clare.storeId,
    store_name: Mocks.clare.storeName,
    store_contact: Mocks.clare.storeContact,
    total: Mocks.clare.amountTen,
    total_unadjusted: Mocks.clare.amountTen,
    type: Mocks.clare.orderType,
    updated_at: Mocks.dates.date2000,
    user_full_name: Mocks.persona.full_name,
    user_id: Mocks.persona.id,
    persona_id: Mocks.persona.id,
    currency_symbol: Mocks.clare.usdSymbol,
    itemized: false,
    reminded_at: null,
    amount_discounted: Mocks.clare.amountZero,
    discounted: false,
    refunded: false,
    credited: false,
    taxable: true,
    items: [sale_item_factory_1.saleItemFactory.build()],
    payments: [sale_payment_factory_1.salePaymentFactory.build()],
    refunds: [],
    transactions: [sale_transaction_factory_1.saleTransactionFactory.build()],
    sale_sources: [sale_source_factory_1.saleSourceFactory.build()],
    registers: [sale_register_factory_1.saleRegisterFactory.build()],
    billing_address: sale_address_factory_1.saleAddressFactory.build(),
    shipping_address: sale_address_factory_1.saleAddressFactory.build(),
    metadata: { 'result_type': Mocks.clare.orderType },
    due_date: Mocks.dates.date2100,
    invoice_group_id: 2,
    invoice_group_number: '2',
    due_date_days_past: 0,
    payment_term: {},
    payment_term_strategy: {},
    customer_pays_fee: false,
    customer_pays_some_or_all_fees: false,
    service_fee_definition_method: 'org_pays',
    commerce_order_id: null,
    payment_plan_options: [],
    fulfillment: {},
});
exports.invoiceFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    amount: Mocks.clare.numberTen,
    amount_outstanding: Mocks.clare.amountZero,
    amount_paid: Mocks.clare.amountTen,
    amount_refunded: Mocks.clare.amountZero,
    amount_charged_back: Mocks.clare.amountZero,
    amount_adjusted: Mocks.clare.amountZero,
    amount_credited: Mocks.clare.amountZero,
    can_comp: false,
    can_void: false,
    cart_id: 2,
    created_at: Mocks.dates.date2000,
    description: 'Test Order',
    email_address: Mocks.persona.email,
    org_id: Mocks.orgClub.id,
    organization_id: Mocks.orgClub.id,
    payment_plan_id: 3,
    payment_plan_payment_method: null,
    placed_at: Mocks.dates.date2000,
    placed_successfully: true,
    sale_number: Mocks.clare.saleNumber,
    salesperson_id: 4,
    salesperson_full_name: null,
    status: 'settled',
    monetary_status: 'paid',
    display_status: Mocks.clare.statusPaid,
    store_id: Mocks.clare.storeId,
    store_name: Mocks.clare.storeName,
    store_contact: Mocks.clare.storeContact,
    total: Mocks.clare.amountTen,
    total_unadjusted: Mocks.clare.amountTen,
    type: Mocks.clare.invoiceType,
    updated_at: Mocks.dates.date2000,
    user_full_name: Mocks.persona.full_name,
    user_id: Mocks.persona.id,
    persona_id: Mocks.persona.id,
    currency_symbol: Mocks.clare.usdSymbol,
    itemized: false,
    reminded_at: null,
    amount_discounted: Mocks.clare.amountZero,
    discounted: false,
    refunded: false,
    credited: false,
    taxable: true,
    items: [sale_item_factory_1.saleItemFactory.build()],
    payments: [sale_payment_factory_1.salePaymentFactory.build()],
    refunds: [],
    transactions: [sale_transaction_factory_1.saleTransactionFactory.build()],
    sale_sources: [sale_source_factory_1.saleSourceFactory.build()],
    registers: [sale_register_factory_1.saleRegisterFactory.build()],
    billing_address: sale_address_factory_1.saleAddressFactory.build(),
    shipping_address: sale_address_factory_1.saleAddressFactory.build(),
    metadata: { 'result_type': Mocks.clare.orderType },
    due_date: Mocks.dates.date2100,
    invoice_group_id: 2,
    invoice_group_number: '2',
    due_date_days_past: 0,
    payment_term: {},
    payment_term_strategy: {},
    customer_pays_fee: false,
    customer_pays_some_or_all_fees: false,
    service_fee_definition_method: 'org_pays',
    commerce_order_id: null,
    payment_plan_options: [],
    fulfillment: {},
});
